import environment from "./src/environment.js";

if (localStorage.getItem("crowdinInContext") === "true" && environment.isDevelopment()) {
  let _jipt = [];
  _jipt.push(["project", "moreapp-platform-new"]);

  window._jipt = _jipt;

  const script = document.createElement("script");
  script.setAttribute("type", "text/javascript");
  script.setAttribute("src", "//cdn.crowdin.com/jipt/jipt.js");
  document.querySelector("head")?.appendChild(script);
}
